export function openDrawer(state) {
  state.showDrawer = true;
}

export function closeDrawer(state) {
  state.showDrawer = false;
}
